import { ComboField } from '@components/Fields/ComboField';
import { Fieldset } from '@components/Fields/Fieldset';
import { VerticalGrid } from '@components/VerticalGrid';
import { useComboBoolean } from '@hooks/useComboBoolean';
import { IForm } from '@hooks/useForm';
import { Grid } from '@material-ui/core';
import SettingsPhoneIcon from '@material-ui/icons/SettingsPhone';
import { IComboContratoOperadora } from '@model/ContratoOperadora';
import ILinha from '@model/Linha';
import React from 'react';


export type LinhaFormularioProps = {
    contratoOperadoraCombo: IComboContratoOperadora
    form: IForm<Partial<ILinha>>
}

export function LinhaFormulario ({form, contratoOperadoraCombo }: LinhaFormularioProps) {
    const linhaEmpresaCombo = useComboBoolean("0");
    const vozIlimitadaCombo = useComboBoolean("1");

    return (
        <VerticalGrid>
            <Fieldset
                icon={<SettingsPhoneIcon />}
                title="Dados da Nova Linha"
            >
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        <ComboField 
                            field={form.fields.contratoOperadoraId}
                            label="Contrato Operadora"
                            required
                            
                        >
                            {contratoOperadoraCombo.createOptions()}
                        </ComboField>
                    </Grid>

                    <Grid item xs={3}>
                        <ComboField 
                            field={form.fields.linhaEmpresa}
                            label="Linha Empresa"
                            required
                            
                        >
                            {linhaEmpresaCombo.createOptions()}
                        </ComboField>
                    </Grid>

                    <Grid item xs={3}>
                        <ComboField 
                            field={form.fields.vozIlimitada}
                            label="Voz Ilimitada"
                            required
                            
                        >
                            {vozIlimitadaCombo.createOptions()}
                        </ComboField>
                    </Grid>
                </Grid>
            </Fieldset>
        </VerticalGrid>
    )
}